import { render, staticRenderFns } from "./UserOtherInterestInfo.vue?vue&type=template&id=0736c11f&"
import script from "./UserOtherInterestInfo.vue?vue&type=script&lang=js&"
export * from "./UserOtherInterestInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports